import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

/** Dark code block with tabs and copy-to-clipboard. */
const CodeSnippet = ({ snippets, className }) => {
  const keys = Object.keys(snippets);
  const [active, setActive] = useState(keys[0]);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippets[active].code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard blocked — the user can still select the text */
    }
  };

  return (
    <div className={cn('rounded-xl border border-slate-800 bg-slate-950 overflow-hidden', className)}>
      <div className="flex items-center justify-between px-3 py-2 border-b border-slate-800 bg-slate-900/60 gap-2">
        <div className="flex gap-3 overflow-x-auto agent-scrollbar">
          {keys.map((key) => (
            <button
              key={key}
              onClick={() => setActive(key)}
              className={cn(
                'text-xs font-medium py-1 whitespace-nowrap transition-colors border-b-2',
                active === key
                  ? 'text-blue-400 border-blue-400'
                  : 'text-slate-400 border-transparent hover:text-slate-200'
              )}
            >
              {snippets[key].label}
            </button>
          ))}
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 shrink-0 text-slate-400 hover:text-white hover:bg-slate-800"
          onClick={copy}
        >
          {copied ? <Check className="w-4 h-4 text-emerald-400" /> : <Copy className="w-4 h-4" />}
        </Button>
      </div>
      <pre className="p-4 overflow-x-auto text-[13px] leading-relaxed font-mono text-slate-300 agent-scrollbar">
        <code>{snippets[active].code}</code>
      </pre>
    </div>
  );
};

export default CodeSnippet;
